import { VendorGetServerSideProps } from 'vendor/utils/VendorGetServerSideProps';
import { QueryKey } from 'src/models/query';
import { MetaTitle } from 'src/components/seo/MetaTitle';
import { useTranslate } from 'react-t7e';
import { MetaDescription } from 'src/components/seo/MetaDescription';
import { configureSSR } from 'src/utils/configureSSR';
import { ShowcasePageTemplate } from 'src/modules/materials/components/ShowcasePage';
import { SearchFilters } from 'src/services/search';
import {
  fetchVideosShowcaseFilters,
  useVideosShowcaseFiltersQuery,
} from 'src/modules/videos/hooks/useVideosShowcaseFiltersQuery';
import {
  fetchVideosShowcaseSections,
  useVideosShowcaseSectionsQuery,
} from 'src/modules/videos/hooks/useVideosShowcaseSectionsQuery';
import { searchItemsByFiltersQuery } from 'src/modules/materials/hooks/useSearchItemsByFiltersQuery';

const MedicalEducationPage = () => {
  const { _ } = useTranslate();

  return (
    <>
      <MetaTitle>
        {_('Medical Education - Injection Techniques, Expert Talks')}
      </MetaTitle>
      <MetaDescription>
        {_(
          '\tWatch online medical aesthetic videos. Injection techniques, Training, Protocol Treatment and Expert Talks',
        )}
      </MetaDescription>
      <ShowcasePageTemplate
        filtersQuery={useVideosShowcaseFiltersQuery}
        sectionsQuery={useVideosShowcaseSectionsQuery}
        itemsToQuery={['videos']}
        defaultFilters={{ showcase: true, status: ['published'] }}
      />
    </>
  );
};

export const getServerSideProps = VendorGetServerSideProps(async (ctx) => {
  const initialFilters = ctx.query as SearchFilters;

  return configureSSR(ctx, {
    layout: {
      variant: 'default',
      tvbar: true,
    },
    cacheControl: {
      maxAge: 600,
      sMaxAge: 1200,
    },
    actions: {
      public: () => [
        ctx.queryClient.prefetchQuery(
          searchItemsByFiltersQuery(
            ctx.apis,
            { ...initialFilters, showcase: true, status: ['published'] },
            {
              itemsToQuery: ['videos'],
            },
          ),
        ),
        ctx.queryClient.prefetchQuery(QueryKey.VideoFilterSections, () =>
          fetchVideosShowcaseSections(ctx.apis),
        ),
      ],
      common: () => [
        ctx.queryClient.prefetchQuery(QueryKey.VideoSearchFilters, () =>
          fetchVideosShowcaseFilters(ctx.apis),
        ),
      ],
    },
  });
});

export default MedicalEducationPage;
